import {Component, OnInit} from '@angular/core';
import {SalesProcessV1Service} from './sales-process-v1.service';
import {ErrorStateMatcher} from '@angular/material/core';
import {FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {ProductService} from '../services/product.service';

export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-lab-loja-page',
  templateUrl: './lab-loja-page.component.html',
  styleUrls: [ './lab-loja-page.component.scss' ]
})
export class LabLojaPageComponent implements OnInit {

  public members: any = [];
  public products: any = [];
  public salesForm: FormGroup;
  public dataPack: any = null;
  public messageError: any = null;

  constructor (
    private fb: FormBuilder,
    private _salesProcessV1Service: SalesProcessV1Service,
    private _productService: ProductService,
    private router: Router,
  ) {
    this.members = [
      {"id": "Wf2AxIoCLGB6MByPRcRH", "name": "Abelardo Barbosa"},
      {"id": "JMeXy75pzHUPztllX5Pv", "name": "Ana Maria de Souza"},
      {"id": "Axyib52ToshktmN0ZbZo", "name": "Carlos Otero"},
      
    ]

    this.loadProducts();
    this.salesForm = this.createForm();
  }

  ngOnInit () {
  }

  loadProducts () {
    this.products = [
      {"id": "HJ63tyU8LSKkUORwCQNT", "name": "T - Produto Normal"},
      {"id": "zSxUJYyF6PzQ93eyYrDg", "name": "T - Produto Combo"},
      {"id": "iD9D90JVrOoiwBFPCwt3", "name": "T - Produto com pré-requisito"},
      {"id": "YA7PhjX97DpLPZ3d9rsP", "name": "T - Produto vagas por tópico"},
    ]
    this._productService.selectProducts()
    .subscribe((result)=>{
      result.forEach((item)=>{
        const itemId = item.payload.doc.id;
        const itemData = item.payload.doc.data();
        if(itemData.part_of !== 3)
        this.products.push({
          "id": itemId,
          "name": itemData.name
        })

      })
    })
  }

  callSalesProcessV1 () {

    this.dataPack = null;

    const formData = this.salesForm.getRawValue();
  
    let memberCpf = formData.member_cpf;
    let memberId = formData.member_id;
    let productId = formData.product_id;

    if (memberCpf){
      memberId = "";
      this.salesForm.controls.member_id.setValue("");
    } 

    const data = {
      "criteria": {
        "memberCpf": memberCpf,
        "memberId": memberId,
        "productId": productId
      }
    }
    //
    this._salesProcessV1Service.salesProcessV1(data)
      .then(async (result: any) => {
        const resultData = result.data
        console.log(JSON.stringify(resultData));

        if (resultData.status !== 1) {
          this.dataPack = resultData;
          this.messageError = null;
        } else {
          this.messageError = resultData.message
          this.dataPack = null;
        }
      })
      .catch((err) => {
        console.log("err", err.message)
      })

  }

  createForm () {
    return this.fb.group({
      member_cpf: new FormControl(''),
      member_id: new FormControl(''),
      product_id: new FormControl('', [ Validators.required ]),
    });
  }

  setDataPackAndGo () {
    sessionStorage.setItem("dataPack", JSON.stringify(this.dataPack))
    this.router.navigate([ 'loja2' ]);
  }



  teste () {
    const data = this.salesForm.getRawValue();
    console.log(JSON.stringify(data))
  }
}
